angular.module('impactx.rfx').controller('RFXOfferCtrl', [
    '$scope',
    'RFXBuyerService',
    '$routeParams',
    'ToolbarService',
    'TranslationService',
    'ToastService',
    '$route',
    'dataGen',
    '$redirect',
    '$copyToClipboard',
    'ColorUtilService',
    'RFXSupplierService',
    '$mdDialog',
    'ConfirmationService',
    'BackService',
    'ProductEuelService',
    RFXOfferCtrl
]);

function RFXOfferCtrl($scope, RFXBuyerService, $routeParams, ToolbarService, TranslationService, ToastService, $route,
                      dataGen, $redirect, $copyToClipboard, ColorUtilService, RFXSupplierService, $mdDialog, ConfirmationService,
                      BackService, ProductEuelService) {
    var self = this;
    $scope.productDataSheetLabel = TranslationService.get("productDataSheet");
    self.productEuelService = ProductEuelService;
    self.offSetForBasketItemGroupColor = 15;
    self.getGroupColor = function (item) {
        if (item.basketItemGroupNumber) {
            return ColorUtilService.getColor(item.basketItemGroupId + self.offSetForBasketItemGroupColor);
        }
        return 'transparent';
    };

    self.extendBorderBasketItemGroup = function (item) {
        var id = item.basketItemGroupId || 0;
        var element = document.getElementsByClassName('basket-item-group-' + (id + self.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    self.shrinkBorderBasketItemGroup = function (item) {
        var id = item.basketItemGroupId || 0;
        var element = document.getElementsByClassName('basket-item-group-' + (id + self.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    self.viewBasketItemGroup = function (event, item, contract) {
        event.stopPropagation();
        var basketItemGroupId = item.basketItemGroupId;
        var groupItems = findBasketItemGroupItems(item.basketItemGroupId, contract);
        RFXSupplierService.showFreeformOfferDialog(event, item.basketItemGroupId, $routeParams.rfqsId, contract.supplierId,
            groupItems, item.basketItemGroupData, contract.id, contract.lotId, true, [contract]);
    };

    function findBasketItemGroupItems (identifier, contract) {
        return contract.items.filter(function (item) {
            return item.basketItemGroupId === identifier;
        });
    }

    self.selectedItems = [];

    self.selectedItemsLabel = function () {
        return self.selectedItems.length + ' ' + $scope.selectedTrns;
    }
    self.unselectAll = function () {
        return self.selectedItems = [];
    }
    self.hasSelectedItems = function () {
        return self.selectedItems.length > 0;
    }

    RFXBuyerService.getRFQSItemData($routeParams.rfqsId).then(function (response) {
        if (response && response.data) {
            self.data = response.data;
            self.trns = response.trns;
            self.trns.addToBasket = TranslationService.get('addToBasket');
            self.hideButtons = response.data.isSimpleSupplierRecommendation;
        }
        defineButtons();
    });

    self.selectPosition = function (position) {
        var index = self.selectedItems.indexOf(position);
        if (index < 0) {
            self.selectedItems.push(position);
        }
        else {
            self.selectedItems.splice(index, 1);
        }
    };

    self.isSelected = function (item) {
        return self.selectedItems.indexOf(item) >= 0;
    };

    self.hasOneSelectedItem = function() {
        return self.selectedItems.length == 1;
    };

    self.canAddToBasket = function() {
        return self.data.canAddToBasket && !self.data.allContractsExpired && !self.data.noOrderExpired;
    };

    self.isInformation = function (item) {
        var policy;
        if (item.smartForm) {
            policy = self.getSmartFormPolicy(item.smartForm.identifier);
        }
        return item.isInformation || (policy && policy.isInformation);
    };

    self.getSmartFormPolicy = function (id) {
        var policies = self.data.smartFormPolicies;
        if (typeof id === 'string') {
            for (var key in policies) {
                if (policies.hasOwnProperty(key) &&
                    policies[key].identifier === id) {
                    return policies[key];
                }
            }
        }
        else if (typeof id === 'number' && !isNaN(id)) {
            return policies[id];
        }
    }

    self.viewPosition = function (event) {
        if (self.selectedItems.length == 1) {
            var selectedItem = self.selectedItems[0];
            RFXBuyerService.showViewPositionDialog(event, self.id, selectedItem, self.trns, self.data.smartFormTemplates);
        }
    };

    self.addToBasket = function () {
        const selectedIds = self.selectedItems.map((item)=>item.id);
        RFXBuyerService.addToBasket(self.data.headerId, $routeParams.rfqsId, selectedIds);
    };

    self.openEditDateDialog = function (event) {
        $mdDialog.show({
            templateUrl: "modules/rfx/templates/rfx-edit-date-dialog.html",
            controller: "RFXEditDateCtrl",
            controllerAs: "rfxEditDateCtrl",
            targetEvent: event,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
                rfqhId: self.data.headerId,
                reload: false
            }
        });
    };

    self.decide = function () {
        $redirect.redirectTo(null, '/rfxbuyerdecide/' + self.data.headerId);
    };

    self.decideEarly = function () {
        return RFXBuyerService.decideEarly(self.data.headerId).then(function () {
            $route.reload().then(function () {
                if (self.canAddToBasket()) {
                    self.addToBasket();
                } else {
                    self.decide();
                }
            });
        });
    };

    self.chooseOffer = function () {
        dataGen.postAsForm({}, {rfqsId: $routeParams.rfqsId}, "/rfx/buyer/decide").then(function () {
            $route.reload();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    self.chooseOfferEarly = function () {
        RFXBuyerService.decideEarly(self.data.headerId).then(function () {
            self.chooseOffer();
        });
    };

    self.rejectInternal = function () {
        dataGen.postAsForm({}, {ids: [self.data.id]}, "/rfx/buyer/rejectOffers").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    self.reject = function (event) {
        ConfirmationService.showConfirmationDialog(function () {
            if (self.data.useTextCustomization) {
                RFXBuyerService.showTextCustomization(event, 0, RFXBuyerService.STATUS.CANCELLED, [self.data.id]).then(function (result) {
                    if (result && result.send) {
                        self.rejectInternal();
                    }
                });
            }
            else {
                self.rejectInternal();
            }
        }, event, self.trns.rejectOfferQuestion, self.trns.reject, TranslationService.get('abort'));
    };

    self.canChooseOffer = function () {
        if (self.data) {
            return self.data.showDecide && !self.allowEarlyChoosing();
        }
    };

    self.disableChooseOffer = function () {
        if (self.data) {
            return !self.data.canChooseOffer;
        }
    }

    self.allowEarlyChoosing = function () {
        if (self.data) {
            return self.data.showDecide && self.data.allowEarlyChoosing
        }
    }

    self.copyCodeToClipboard = function () {
        var code = impactX.isDefined(self, 'data.offerCode.value');
        if (code) {
            $copyToClipboard.copy(code).then(function () {
                ToastService.openStandardToast(self.trns.copySuccess);
            });
        }
    }

    function canDecide() {
        return self.data.showDecide && !allowEarlyDecision() && !self.data.allContractsExpired && !self.data.noOrderExpired;
    }

    function disableDecide() {
        return !self.data.canDecide;
    }

    function allowEarlyDecision() {
        return self.data.showDecide && self.data.allowEarlyDecision && !self.data.allContractsExpired && !self.data.noOrderExpired;
    }

    var canShare = function () {
        return self.data.canShare;
    };

    var canReject = function () {
        return self.data.canReject;
    };

    function defineButtons() {
        $scope.selectedTrns = TranslationService.get('selected');
        var buttonDefinition;
        if (!self.data.isSimpleSupplierRecommendation) {
            buttonDefinition = [
                {
                    icon: 'mdi-close',
                    labelFunction: self.selectedItemsLabel,
                    action: self.unselectAll,
                    condition: self.hasSelectedItems
                },
                {
                    label: self.trns.details,
                    action: self.viewPosition,
                    type: 'dialogaction',
                    condition: self.hasOneSelectedItem
                },
                {
                    label: self.trns.addToBasket,
                    action: self.addToBasket,
                    type: 'dialogaction',
                    condition: self.canAddToBasket
                },
                {
                    label: self.trns.requestDetails,//"Anfragedetails",
                    linkFunction: getDetailLink,
                    type: 'link',
                },
                {
                    label: self.trns.decide,
                    action: self.decide,
                    type: 'validation',
                    condition: canDecide,
                    params: {
                        form: $scope.dialogData,
                        disableExpression: {
                            valueFunction: disableDecide,
                            error: self.trns.decisionNotAllowedUntil
                        }
                    }
                },
                {
                    label: self.trns.decide,
                    action: self.decideEarly,
                    type: 'dialogaction',
                    condition: allowEarlyDecision
                },
                {
                    label: self.trns.reject,
                    action: self.reject,
                    type: 'dialogaction',
                    condition: canReject
                },
                {
                    label: self.trns.share,
                    action: self.shareRFX,
                    type: 'dialogaction',
                    condition: canShare
                }
            ];
        } else {
            buttonDefinition = [
                {
                    label: self.trns.requestDetails,
                    linkFunction: getDetailLink,
                    type: 'link',
                }
            ];
        }
        ToolbarService.setButtons(buttonDefinition);
    }

    this.shareRFX = function (event) {
        $mdDialog.show({
            controller: "RFXShareDialogCtrl",
            controllerAs: "rfxShareDialogCtrl",
            templateUrl: "modules/rfx/templates/rfxshare.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                title: self.trns.share,
                hint: self.trns.shareHint,
                atLeastOneMailLabel: self.trns.atLeastOneMail,
                sendLabel: self.trns.send,
                rfqsId: $routeParams.rfqsId
            },
            bindToController: true
        });
    };
    function getDetailLink() {
        return "rfxbuyer/" + self.data.headerId;
    }
}